import getTemplate from './get/template.html';
import getCtrl from './get/controller';

const authorEvaluationFormsState = {
  url: '/evaluation-forms',
  stateName: 'Evaluation Forms',
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass =>
      ResolveClass.authenticateCompany('/author/:id/evaluation-forms')
  },
  views: {
    'a@app': {
      template: getTemplate,
      controller: getCtrl,
      controllerAs: 'authorEvaluationFormsCtrl'
    }
  },
  data: {
    specialClass: 'fixed-sidebar',
    pageTitle: 'Evaluation Forms'
  }
};

import editTemplate from './edit/template.html';
import editCtrl from './edit/controller';

const authorEvaluationFormsEvaluationFormEditState = {
  url: '/edit?tour',
  stateName: 'Evaluation Form Edit',
  views: {
    'a@app': {
      template: editTemplate,
      controller: editCtrl,
      controllerAs: 'authorEvaluationFormEditCtrl'
    }
  },
  data: {
    pageTitle: 'Evaluation Form Edit'
  }
};

import viewTemplate from './view/template.html';
import viewCtrl from './view/controller';

const authorEvaluationFormsEvaluationFormState = {
  url: '/:form_id',
  stateName: 'Evaluation Form',
  views: {
    'a@app': {
      template: viewTemplate,
      controller: viewCtrl,
      controllerAs: 'authorEvaluationFormViewCtrl'
    }
  },
  data: {
    specialClass: 'fixed-sidebar',
    pageTitle: 'Evaluation Form'
  }
};

export {
  authorEvaluationFormsState,
  authorEvaluationFormsEvaluationFormState,
  authorEvaluationFormsEvaluationFormEditState
};



// WEBPACK FOOTER //
// ./src/app/controllers/author/evaluationForms/index.js